import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MensagemControleSituacao } from './mensagem-controle-situacao.model';
import {MensagemControle} from './mensagem-controle.model';
import { RespostaProcessamento } from './resposta-processamento.model';
import {BaseService} from '../services/base-service.service';
import {ConsultaPaginada, ConsultaPaginadaResultado} from 'maestro-ng';
import {firstValueFrom} from 'rxjs';


@Injectable()
export class MensagemControleService extends BaseService<MensagemControle, number> {


  constructor(http: HttpClient) {
    super('mensagemControle', http);
  }

  public newEntity(): MensagemControle {
    return {};
  }

  public recuperarPaginado(consulta: ConsultaPaginada): Promise<ConsultaPaginadaResultado<MensagemControle>> {

    if ( consulta.restricoes.some(item => item.atributo === 'topico') === false) {
      return;
    }

    return this.service.recuperarPaginado(consulta);
  }

  public getId(entity: MensagemControle): number {
    return entity.id;
  }

  public executarNovamentePorTopicoParticaoEhId(mensagemControle: MensagemControle): Promise<RespostaProcessamento> {
    return firstValueFrom(this.http.get<RespostaProcessamento>(this.path(`executarNovamente/${mensagemControle.topico}/${mensagemControle.particao}/${mensagemControle.id}`)));
  }

  public recuperarTopicos(): Promise<String[]> {
    return  firstValueFrom(this.http.get<String[]>(this.path('recuperarTopicos')));
  }

  public getTipoSituacaoCor(tipoSituacao: MensagemControleSituacao): string {
    switch (tipoSituacao) {
      case MensagemControleSituacao.FALHA_PROCESSAMENTO:
      case MensagemControleSituacao.QUARENTENA:
      case MensagemControleSituacao.SUSPENSA:
        return 'red';
      default:
      case MensagemControleSituacao.NAO_PROCESSADA:
        return 'gray';
    }
  }
}
